import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { SearchService } from '../../services/search/search.service';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { Utils } from '../../../utils/utils';
import * as fromModel from '../../services/models/';
import { ReferenceService } from '../../services/reference/reference.service';
import { RefDataService } from '../../services/context/ref-data.service';
import { Constant } from '../../../environments/constants';

@Component({
  selector: 'gp-client-profile',
  templateUrl: './client-profile.component.html',
  styleUrls: ['./client-profile.component.scss']
})
export class ClientProfileComponent implements OnInit {

  primaryClient: fromModel.PlanClient;
  secondaryClient: fromModel.PlanClient;
  isBusinessClient = false;
  buinessClientTooltip = Constant.ToolTips.buinessClientTooltip;
  isSecClSelected = false;
  gender;
  secGender;
  selectedState: string;
  secSelectedState: string;
  searchControl = new FormControl('', [Validators.maxLength(12)]);
  dobPrimary = new FormControl('', [Validators.required]);
  dobSecondary = new FormControl('', [Validators.required]);
  empIncome = new FormControl({ value: '', disabled: true }, [Validators.maxLength(10)]);
  secEmpIncome = new FormControl({ value: '', disabled: true }, [Validators.maxLength(10)]);
  clientList: any[] =  [];
  accountList: any[] = [];

  states: fromModel.CodeValue[] = [];
  events: string[] = [];

  selectedEmpType: fromModel.EMPLOYMENTTYPE;
  secSelectedEmpType: fromModel.EMPLOYMENTTYPE;
  empTypes: fromModel.CodeValue[] = [];

  
  @Input("Plan") inFlightPlan : fromModel.Plan;
  @Output() ValidateProfile: EventEmitter<fromModel.PlanClient[]> = new EventEmitter();
  
  constructor(private searchService: SearchService, 
              private referenceService: ReferenceService,
              private refDataService: RefDataService,
              private currencyPipe: CurrencyPipe) { }

  ngOnInit(): void {

    this.searchControl.valueChanges
    .pipe(
      debounceTime(500)
    ).subscribe (
      searchText => {
        //if(searchText){
          this.searchService.searchClients(searchText).subscribe(
            searchResultResult => {
              this.clientList = <any[]>searchResultResult;                       
            }
          );
          this.searchService.searchAccounts(searchText).subscribe(
            searchResultResult => {
              this.accountList = <any[]>searchResultResult;                       
            }
          );
        //}  
      }
    );

    // this.empIncome.valueChanges.subscribe(value=>{
    //   this.empIncome.setValue(this.currencyPipe.transform(Utils.getCurrency(value), 'USD', 'symbol', '1.0-0'), {emitEvent: false});      
    // });

    // this.secEmpIncome.valueChanges.subscribe(value=>{
    //   this.secEmpIncome.setValue(this.currencyPipe.transform(Utils.getCurrency(value), 'USD', 'symbol', '1.0-0'), {emitEvent: false});      
    // });

    this.referenceService.getStatesRefrenceData().subscribe(statesRef =>{
      let _states = <fromModel.CodeValue[]>statesRef;
      _states.forEach(state => {
        this.states.push(state);
      });      
    });

    // this.referenceService.getEmploymentTypesRefrenceData().subscribe(empTypeRef =>{
    //   let _empTypes = <fromModel.CodeValue[]>empTypeRef;
    //   _empTypes.forEach(empType => {
    //     this.empTypes.push(empType);
    //   });      
    // });

    this.empTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.EmploymentTypes);

    if(this.inFlightPlan && this.inFlightPlan.planClients && this.inFlightPlan.planClients.length>0){
      this.inFlightPlan.planClients.forEach(cl => {
       if(cl && cl.role === fromModel.CLIENTROLE.Primary){
         this.primaryClient = cl;
         this.dobPrimary.setValue(this.primaryClient.dob);         
       } else if(cl && cl.role === fromModel.CLIENTROLE.Secondary){
          this.secondaryClient = cl;
          this.dobSecondary.setValue(this.secondaryClient.dob);         
       } 
     }); 
    }
    this.empIncome.valueChanges
      .subscribe(query => {
        this.empIncome.setValue(this.currencyPipe.transform(Utils.getCurrency(query), 'USD', 'symbol', '1.0-0'), {emitEvent: false});      
        this.primaryClient.salary = Utils.getNumber(query);
        this.onValidateProfile();
    });
    this.secEmpIncome.valueChanges
    .subscribe(query => {
      this.secEmpIncome.setValue(this.currencyPipe.transform(Utils.getCurrency(query), 'USD', 'symbol', '1.0-0'), {emitEvent: false});      
      this.secondaryClient.salary = Utils.getNumber(query);
      this.onValidateProfile();
  });

    this.onValidateProfile();
  }

  dobChangeEvent(type: string, event: MatDatepickerInputEvent<Date>, dobFor: string) {
    this.events.push(`${type}: ${event.value}`);
    if(dobFor === "primary"){
      this.primaryClient.dob = this.dobPrimary.value;
      this.primaryClient.age = Utils.calculateAge(event.value.toString());      
    } else  if(dobFor === "secondary"){
      this.secondaryClient.dob = this.dobSecondary.value;
      this.secondaryClient.age = Utils.calculateAge(event.value.toString());      
    }

    this.onValidateProfile();
  }

  onValidateProfile(){
    let profiles: fromModel.PlanClient[] = [];
    if(this.primaryClient 
        && this.primaryClient.age>=18 
        && this.primaryClient.gender 
        && this.primaryClient.stateOfResi
        && ((this.primaryClient.empType === fromModel.EMPLOYMENTTYPE.EMP && this.primaryClient.salary>0)
        || (this.primaryClient.empType === fromModel.EMPLOYMENTTYPE.SEMP && this.primaryClient.salary>0)
        || (this.primaryClient.empType === fromModel.EMPLOYMENTTYPE.RET)
        || (this.primaryClient.empType === fromModel.EMPLOYMENTTYPE.NOW))
        ) {
          if(this.validateSecClient()){
            profiles.push(this.primaryClient);
            this.ValidateProfile.emit(profiles);
          } else {
            this.ValidateProfile.emit(profiles);  
          }
    } else {
          this.ValidateProfile.emit(profiles);
    }
  }

  validateSecClient(){
    let isValidSecClient = false;
    if(this.secondaryClient){
      if(this.secondaryClient.age>=18 
        && this.secondaryClient.gender 
        && this.secondaryClient.stateOfResi
        && (
          (this.secondaryClient.empType === fromModel.EMPLOYMENTTYPE.EMP && this.secondaryClient.salary>0)
       || (this.secondaryClient.empType === fromModel.EMPLOYMENTTYPE.SEMP && this.secondaryClient.salary>0)
       || (this.secondaryClient.empType === fromModel.EMPLOYMENTTYPE.RET)
       || (this.secondaryClient.empType === fromModel.EMPLOYMENTTYPE.NOW))
       && (this.primaryClient.clientid !== this.secondaryClient.clientid)) {
          isValidSecClient = true;  
      } else {
        isValidSecClient = false;
      }
    } else {
       isValidSecClient = true;
    }
    return isValidSecClient;

  }

  selectGender(role){
    if(role === fromModel.CLIENTROLE.Primary){
      this.primaryClient.gender = this.gender;
    } else if(role === fromModel.CLIENTROLE.Secondary){
      this.secondaryClient.gender = this.secGender;
    }
    
    this.onValidateProfile();
  }

  selectState(event: any, value: string, role:fromModel.CLIENTROLE){ 
    if(event.isUserInput){
      if(role === fromModel.CLIENTROLE.Primary){
        this.selectedState = value; 
        this.primaryClient.stateOfResi = value;   
      } else if(role === fromModel.CLIENTROLE.Secondary){
        this.secSelectedState = value; 
        this.secondaryClient.stateOfResi = value;   
      }
      //this.preparePlanExpense(this.selectedState);
      this.onValidateProfile();
    }
  } 

  selectEmpType(event: any, value: string, role:fromModel.CLIENTROLE){
    if(event.isUserInput){
      if(role === fromModel.CLIENTROLE.Primary){
        if(value==='RET' || value==='NOW'){
          this.empIncome.setValue('');        
          this.empIncome.disable();
        } else {        
          this.empIncome.setValue(''); 
          this.empIncome.enable();
        }
        this.primaryClient.empType = <fromModel.EMPLOYMENTTYPE>value;  
      }
      if(role === fromModel.CLIENTROLE.Secondary){
        if(value==='RET' || value==='NOW'){
          this.secEmpIncome.setValue('');        
          this.secEmpIncome.disable();
        } else {        
          this.secEmpIncome.enable();
        }
        this.secondaryClient.empType = <fromModel.EMPLOYMENTTYPE>value;  
      }
      this.onValidateProfile();
    }
  }

  onClientSelectionChange(selectedClient){ 
    this.onRemoveSecClient();
    this.prepareSecondaryClient(selectedClient);
    this.prepareSecondaryClientAccounts(selectedClient);
    this.onValidateProfile();
    this.isSecClSelected = true;
  }

  onAccountSelectionChange(selectedAccount){
    this.onClientSelectionChange(selectedAccount);
  }

  prepareSecondaryClient(selectedClient){
    let cl;
    if(selectedClient){
        cl = selectedClient;      
        this.dobSecondary.setValue(cl.dateofBirth);          
        this.secondaryClient = {
          clientid: cl.LegalEntityID,
          clientname: cl.LegalEntityName,
          dob: cl.dateofBirth,
          age: Utils.calculateAge(cl.dateofBirth),
          endAge: 90,
          gender: '',
          stateOfResi: '',
          role: fromModel.CLIENTROLE.Secondary,
          retAge: fromModel.DEFAULTS.retAge,    
          salary: 0,
          isIncluded: true 
        }
        if(!(cl.legalEntityType==='Individual' || cl.legalEntityType==='P')){
          this.isBusinessClient = true;
        }
    }
    this.inFlightPlan.planClients.push(this.secondaryClient);
    //return this.secondaryClient;
  }

  prepareSecondaryClientAccounts(selectedClient){
    let _a: fromModel.PlanAccount; 
    if(selectedClient && selectedClient.Account){
      selectedClient.Account.forEach(ac => {
        _a = {
          actNo: ac,
          clientid: selectedClient.LegalEntityID,
          isIncluded: true 
        }
        this.inFlightPlan.planAccounts.push(_a);
      });      
    }
  }

  onChangeClient(){
    this.isSecClSelected = false;
  }

  onRemoveSecClient(){
    let secCl = this.inFlightPlan.planClients.find(cl=>cl.role === fromModel.CLIENTROLE.Secondary);
    if(secCl){
      const elePosition = this.inFlightPlan.planClients.indexOf(secCl);
      if(elePosition > -1){
        this.inFlightPlan.planClients.splice(elePosition, 1);  
        this.dobSecondary.setValue('');
        this.secGender = '';
        this.secSelectedState = '';
        this.secSelectedEmpType = fromModel.EMPLOYMENTTYPE.NONE;
        this.secEmpIncome.setValue('');
      }      
    }
    this.isBusinessClient = false;
    this.secondaryClient = null;
    this.onValidateProfile();
    this.isSecClSelected = false;    
  }

}

